import React, { useState } from "react";
import { MenuIcon, XIcon } from "@heroicons/react/outline";
import { IconButton } from "@mui/material";
import { useSpring, animated } from "react-spring";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/solid";
import classes from "./Nav.module.css";
import { Bounce, Fade, Flip, Slide, Zoom } from "react-reveal";

const Nav = ({ active }) => {
  // const [burgerStatus, setBurgerStatus] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className={classes.header_main_div}>
      <main className="flex items-center transition-all duration-300 ease-out  md:p-2  justify-between px-0 mx-auto max-w-[1320px]">
        <div onClick={() => navigate("/")} className="cursor-pointer ">
          <img
            className="min:w-[190px] max:w-[192px] h-[68px]"
            src={require("../images/logo.png")}
            alt=""
          />
        </div>

        <div
          className={`absolute top-0 right-0 flex-col rounded-bl-md justify-center p-8 text-[#fff]   duration-200 ease-out mt-24 xl:items-center xl:flex-row xl:space-x-2 xl:static bg-[#fff] xl:bg-transparent xl:mt-0 xl:p-0 xl:inline-flex ${
            !isOpen ? "hidden" : "inline-flex"
          }
          `}
        >
          <Link to="/content-creators">
            <p
              className={`p-3 xl:-mt-0   font-semibold
              ${active === "contentCreators" ? "text-[#fff]" : "text-[#1b0c3e]"}
               ${active === "contentCreators" ? "bg-[#508dff]" : "bg-[#fff]"}
               mb-1  text-xl hover:bg-[#508dff] hover:text-white
             rounded-md cursor-pointer    lg:px-4 -mt-4   transition-all duration-300 ease-in`}
            >
              Who its for
            </p>
          </Link>
          <div className={classes.price_button}>
            <div
              onClick={() => navigate("/pricing")}
              className={
                active === "pricing"
                  ? classes.header_nav_btn_price_active
                  : classes.header_nav_btn_price
              }
            >
              <p className={`font-semibold mx-[7px] mb-1 text-xl`}>Pricing</p>
              <ChevronDownIcon className={classes.price_down_icon} />
            </div>
            <Fade>
              <div className={classes.price_hover_container}>
                <p className={classes.price_p}>Youtube Videos</p>
                <p className={classes.price_p}>Reels, TikToks, Shorts</p>
                <p className={classes.price_p}>Thumbnails</p>
              </div>
            </Fade>
          </div>

          <Link to="/how-it-works">
            <p
              className={`p-3 xl:-mt-0   font-semibold
              ${active === "howItWorks" ? "text-[#fff]" : "text-[#1b0c3e]"}
               ${active === "howItWorks" ? "bg-[#508dff]" : "bg-[#fff]"}
               mb-1  text-xl hover:bg-[#508dff] hover:text-white
             rounded-md cursor-pointer    px-4 -mt-4   transition-all duration-300 ease-in`}
            >
              How It Works
            </p>
          </Link>
          <Link to="/reviews">
            <p
              className={`p-3 xl:-mt-0   font-semibold
              ${active === "reviews" ? "text-[#fff]" : "text-[#1b0c3e]"}
               ${active === "reviews" ? "bg-[#508dff]" : "bg-[#fff]"}
               mb-1  text-xl hover:bg-[#508dff] hover:text-white
             rounded-md cursor-pointer    lg:px-4 -mt-4   transition-all duration-300 ease-in`}
            >
              Reviews
            </p>
          </Link>
          <Link to="/about">
            <p
              className={`p-3 xl:-mt-0   font-semibold
              ${active === "about" ? "text-[#fff]" : "text-[#1b0c3e]"}
               ${active === "about" ? "bg-[#508dff]" : "bg-[#fff]"}
               mb-1  text-xl hover:bg-[#508dff] hover:text-white
             rounded-md cursor-pointer    lg:px-4 -mt-4   transition-all duration-300 ease-in`}
            >
              About us
            </p>
          </Link>

          <Link to="/contact-us">
            <p
              className={`p-3 xl:-mt-0   font-semibold
              ${active === "contact" ? "text-[#fff]" : "text-[#1b0c3e]"}
               ${active === "contact" ? "bg-[#508dff]" : "bg-[#fff]"}
               mb-1  text-xl hover:bg-[#508dff] hover:text-white
             rounded-md cursor-pointer    lg:px-4 -mt-4   transition-all duration-300 ease-in`}
            >
              Contact us
            </p>
          </Link>
          {/* <a href="">
            <p className="p-3 bg-[#f8cc84]   transition-all duration-200 ease-out text-[#1b0c3e] px-6 text-xl hover:opacity-60 font-semibold rounded-md cursor-pointer sm:p-4 xl:mb-0 sm:hidden">
              Dashbord login
            </p>
          </a> */}
        </div>
        {/* <div className="flex items-center lg:space-x-5">
          <a href="">
            <p className="p-3 hover:bg-opacity-90 bg-[#f8cc84]  transition-all duration-200 ease-out text-[#1b0c3e] px-6 text-xl font-semibold rounded-md cursor-pointer sm:p-4 xl:mb-0  xl:mr-0 mr-20 hidden sm:inline-flex hover:bg-[#e8c181]">
              Dashbord login
            </p>
          </a>
        </div> */}
      </main>
      <Sidebar active={active} />
    </div>
  );
};

export default Nav;
